<section class="workflow-binding-shell row g-4">
  <div class="col-12 col-xl-8">
    <article class="bg-white border rounded-4 shadow p-3 h-100">
      <div class="workflow-binding-header d-flex flex-column flex-md-row align-items-start justify-content-between gap-3">
        <div>
          <h2 class="fs-5 fw-bold mb-1">Active Workflow Bindings</h2>
          <p class="entity-panel-caption small fw-semibold">Automate the progression and approval cycles for this entity.</p>
        </div>

      </div>

      <div class="mt-2">
        <div class="entity-new-binding-card bg-white border rounded-4 shadow p-3 mb-3">
          <div class="row g-3 align-items-end">
            <div class="col-12 col-lg-9">
              <div class="d-flex align-items-start gap-2 mb-3">
                <div class="entity-new-binding-icon rounded-3 d-inline-flex align-items-center justify-content-center flex-shrink-0">
                  <i class="bi bi-link-45deg"></i>
                </div>
                <div>
                  <div class="fw-bold small mb-1">Add Workflow Binding</div>
                  <div class="entity-panel-caption small fw-semibold">
                    Bind a workflow to this entity setup.
                  </div>
                </div>
              </div>
              <label class="form-label mb-1 fw-semibold text-uppercase entity-binding-field-label">Select Workflow</label>
              <div ref="workflowMultiselect" class="template-multiselect position-relative">
                <button
                  type="button"
                  class="form-select subsystem-select entity-binding-control rounded-small d-flex align-items-center justify-content-between gap-2"
                  :disabled="creatingWorkflowBinding"
                  @click="toggle_workflow_dropdown"
                >
                  <span class="text-truncate">{{ selected_workflows_label }}</span>
                  <i class="bi bi-chevron-down small"></i>
                </button>

                <div v-if="workflow_dropdown_open" class="template-multiselect-menu rounded-small shadow-sm mt-1 p-2">
                  <div v-if="!availableWorkflows.length" class="px-2 py-1 small text-secondary">
                    No unbound workflows available
                  </div>
                  <div v-else class="template-multiselect-items">
                    <label
                      v-for="workflow in availableWorkflows"
                      :key="workflow.id"
                      class="template-multiselect-item d-flex align-items-center gap-2 px-2 py-1 rounded-small"
                    >
                      <input
                        class="form-check-input mt-0"
                        type="checkbox"
                        :value="String(workflow.id)"
                        v-model="local_selected_workflow_ids"
                        :disabled="creatingWorkflowBinding"
                      />
                      <span class="small text-truncate">{{ workflow.name || workflow.workflow_name }}</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 col-lg-3">
              <button
                type="button"
                class="btn entity-create-binding-btn rounded-small shadow-sm px-3 py-2 fw-semibold border-0 text-white w-100 d-inline-flex align-items-center justify-content-center gap-2"
                :disabled="creatingWorkflowBinding || !local_selected_workflow_ids.length"
                @click="bind_selected_workflows"
              >
                <i class="bi bi-link-45deg"></i>
                <span class="text-x">{{ creatingWorkflowBinding ? 'Binding...' : 'Bind workflow(s)' }}</span>
              </button>
            </div>
          </div>
        </div>

        <p class="fw-bold text-x">Current Bindings </p>
        <div class="d-flex flex-column gap-3">
          <article
            v-for="binding in current_bindings"
            :key="binding.id"
            class="entity-binding-list-card bg-white rounded-4 p-3 d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between gap-3"
          >

            <div class="d-flex align-items-start gap-3 flex-grow-1">
              <div class="workflow-binding-icon d-inline-flex align-items-center justify-content-center rounded-3 flex-shrink-0">
                <i class="bi bi-arrow-counterclockwise"></i>
              </div>

              <div class="flex-grow-1">
                <div class="d-flex flex-column flex-lg-row align-items-start align-items-lg-center gap-2 mb-1">
                  <div class="text-x fw-semibold text-dark">{{ binding.workflow_name }}</div>
                  <span class="workflow-binding-status-pill text-xxs">{{ binding.status }}</span>
                </div>

                <div class="small text-secondary lh-base">
                  {{ binding.stage_summary }}
                </div>
              </div>
            </div>

            <button
              type="button"
              class="btn btn-link btn-sm p-0 text-danger text-decoration-none small fw-semibold"
              @click="$emit('remove-workflow', binding.raw)"
            >
              <i class="bi bi-trash3 me-1"></i>
              Remove
            </button>

          </article>

          <div v-if="!has_workflow" class="workflow-binding-empty-state rounded-4 p-3 small text-secondary bg-white">
            No workflow bindings yet. Select a workflow above and bind it.
          </div>
        </div>
      </div>
    </article>
  </div>

  <div class="col-12 col-xl-4">
    <div class="entity-overview-profile-card rounded-4 border shadow p-4 h-100 overflow-hidden">
      <h2 class="entity-overview-title fw-bold mb-3">Entity Overview</h2>
      <div class="small mb-4">
        <div class="entity-panel-caption fw-semibold">Current Workflow Bindings for</div>
        <div class="fw-bold">{{ entityTypeName }}</div>
      </div>

      <div class="entity-overview-divider"></div>

      <div class="d-flex flex-column gap-3 my-4">
        <div class="d-flex align-items-center justify-content-between gap-2">
          <span class="small text-secondary">Active Workflows</span>
          <span class="small fw-bold">{{ workflow_count }}</span>
        </div>
        <div class="d-flex align-items-center justify-content-between gap-2">
          <span class="small text-secondary">Form Sources</span>
          <span class="small fw-bold">{{ formBindingsCount }}</span>
        </div>
      </div>

      <button type="button" class="btn entity-overview-profile-btn rounded-small w-100 small fw-semibold">
        <i class="bi bi-eye me-2"></i>
        View Full Profile
      </button>
    </div>
  </div>
</section>
